import { QueryConfig } from "store/utils/query-config";

export const supplierBillPaymentReceiptsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["addedAt"],
  },
};

export function supplierBillPaymentReceiptsQueryForBooking(
  bookingId: string
): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["addedAt"] },
  };
}
